import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';

export function useUploadOrgAvatar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ tenantId, file }: { tenantId: string; file: File }) =>
      organizationsService.uploadAvatar(tenantId, file),
    onSuccess: (_, { tenantId }) => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATIONS_KEYS.detail(tenantId, tenantId),
      });
    },
  });
}
